import * as Device from 'expo-device';
import { Platform } from 'react-native';
import launch from './launchArguments/launchArguments';
import { channel } from 'expo-updates';
import { createURL } from 'expo-linking';
import { isWeb } from './designSystem/Layout';


const demoApp= 'https://app.demo.evoluno.com/';
const productionApp= 'https://app.evoluno.com/';

const demoApi = 'https://demo.evoluno.com/';
const productionApi = 'https://admin.evoluno.com/';


// `localhost` is the device itself on an Android emulator, not the machine
// running the API: 10.0.2.2 is the emulator's alias for the host. Either is
// overridden by EXPO_PUBLIC_API_URL (see getApiUrl below).
const localApi = Platform.OS === 'android'
  ? 'http://10.0.2.2:4040/'   // android emulator -> host
  : 'http://localhost:4040/'; // ios simulator / web
// const localApi = 'http://192.168.129.2:4040/'; // home wifi
// const localApi = 'http://192.168.1.28:4040/'; // home ethernet
// const localApi = 'http://192.168.11.104:4040/'; //tedesco
// const localApi = 'http://10.10.122.15:4040/'; //anderlecht
// const localApi = 'http://10.140.28.133:4040/'; // silver square
// const localApi = 'http://192.168.0.107:4040/'; // svilengrad
// const localApi = 'http://192.168.43.149:4040/'; // hot spot
// const localApi = productionApi;

export const Iphone11ScreenSize = 896;


type channelType = undefined | 'default' | 'production' | 'demo' | '' | 'preview';




const getApiUrl = (channel: channelType): undefined | string => {
  if (process.env.EXPO_PUBLIC_API_URL) {
    return process.env.EXPO_PUBLIC_API_URL + '/';
  } else if (process.env.EXPO_PUBLIC_TEST) {
    const { apiUrl } = launch.getLaunchArguments();
    return apiUrl;
  } else {
    if (channel === 'default' || channel === undefined || channel === '') {
      return localApi;
    } else if (channel === 'demo' || channel === 'preview') {
      return demoApi;
    } else if (channel === 'production') {
      return productionApi;
    } else {
      return localApi;
    }
  }
};

export const getStoreUrl = (): string | null | undefined => {
  let url = null;
  if(Device.osName === 'iOS'){
    url = process.env.EXPO_PUBLIC_APP_STORE_URL;
  } else if(Device.osName === 'Android') {
    url = process.env.EXPO_PUBLIC_PLAY_STORE_URL;
  }
  return url;
};

export const getChannel = (): undefined | string => {
  if (isWeb && process.env.EXPO_PUBLIC_API_URL) {
    if(process.env.EXPO_PUBLIC_API_URL.includes('demo')) {
      return 'demo';
    }
    if(process.env.EXPO_PUBLIC_API_URL.includes('admin')) {
      return 'production';
    } else {
      return 'preview';
    }
  } else {
    return channel ? channel:'dev';
  }
};

const getAppUrl = (channel: channelType): string => {
  if(channel === 'production'){
    return productionApp;
  } else if (channel === 'demo' || channel === 'preview') {
    return demoApp;
  } else {
    const url = createURL('');
    return url;
  }
};


export const URL = getApiUrl(channel as channelType);
export const APP_URL = getAppUrl(channel as channelType);

export const GRAPHQL_URL = `${URL}en/graphql`;

export const SENTRY_DSN = 'https://d8d660155e31421f939995bba0b0bf01@o498490.ingest.sentry.io/5589657';

export const AMPLITUDE_KEY = 'f62ed2e70a3b518557ee2de6c6485e73';

export const DEFAULT_LANGUAGE = 'fr';
export const DEFAULT_LANGUAGE_LONG = 'Français';

export const STATIC_PAGES = ['terms-and-conditions', 'data-policy'];

export const ICONS: {
  [key: string]: string;
} = {
  'terms-and-conditions': 'legal',
  'data-policy': 'database',
};

export const UNIVERSAL_LINK_URLS = () => {
  const chan = getChannel();

  const UNIVERSAL_LINKS = [];
  if(chan) {
    if(['dev','devfordevice', 'preview','demo'].includes(chan)){
      UNIVERSAL_LINKS.push('http://app.demo.evoluno.com/');
      UNIVERSAL_LINKS.push('https://app.demo.evoluno.com/');
    }
    if(['dev','devfordevice', 'preview'].includes(chan)) {
      UNIVERSAL_LINKS.push('http://localhost:19006/');
    }
    if(chan === 'production') {
      UNIVERSAL_LINKS.push('http://app.evoluno.com/');
      UNIVERSAL_LINKS.push('https://app.evoluno.com/');
    }
  }
  return UNIVERSAL_LINKS;
};

export const CONTENT_URL = 'https://s3.eu-west-1.amazonaws.com/evoluno.app.files/contentFile/';

export const SEGMENT_API = 'mV4mCoaWVUCjL13VcY9HkfP2F18blE0K';

export const ONE_SIGNAL_API = 'fb23180b-0a1d-41e1-9bb3-9807e486d65e';

export const DEFAULT_COMPANY_REGION = {
  region: 'BE',
  language: 'fr',
};
